import { render, staticRenderFns } from "./DashboardKpiCmp.vue?vue&type=template&id=36607438&scoped=true&"
import script from "./DashboardKpiCmp.vue?vue&type=script&lang=js&"
export * from "./DashboardKpiCmp.vue?vue&type=script&lang=js&"
import style0 from "./DashboardKpiCmp.vue?vue&type=style&index=0&id=36607438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36607438",
  null
  
)

export default component.exports